import { Paper, PaperProps, styled } from '@mui/material';
import { forwardRef } from 'react';

export const MapControl = styled(
  forwardRef<HTMLDivElement, PaperProps>((props, ref) => (
    // https://mui.com/material-ui/react-dialog/#non-modal-dialog
    <Paper
      ref={ref}
      {...props}
      role='dialog'
      aria-modal='false'
      variant='outlined'
      sx={{
        ...props.sx,
      }}
    />
  ))
)({});
